// Reaktiver Mini-Store ohne Framework. Bewusst klein gehalten:
// Komponenten subscriben auf einen oder mehrere Stores und reagieren
// auf Aenderungen — kein globaler Pub/Sub, kein Event-Bus.
//
// Nutzung:
//   const s = createStore('h1');
//   const off = s.subscribe(v => console.log(v));
//   s.set('h2');   // -> Listener feuert
//   off();         // unsubscribe

export type Listener<T> = (value: T, prev: T) => void;

export interface Store<T> {
  get(): T;
  set(value: T): void;
  subscribe(listener: Listener<T>): () => void;
}

export function createStore<T>(initial: T): Store<T> {
  let value = initial;
  const listeners = new Set<Listener<T>>();

  return {
    get: () => value,
    set: (next: T) => {
      if (Object.is(next, value)) return;
      const prev = value;
      value = next;
      listeners.forEach((l) => l(value, prev));
    },
    subscribe: (l: Listener<T>) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
  };
}

// =============================================================
// Tour-State
// =============================================================
//
// Single Source of Truth fuer die aktuelle Auswahl. Buildings, Floors
// und Rooms werden ausschliesslich ueber ihre IDs referenziert; die
// vollen Objekte werden bei Bedarf ueber selectByIds aus der Tour-
// Definition aufgeloest.

export const currentBuildingId = createStore<string>('');
export const currentFloorId = createStore<string>('');
export const currentRoomId = createStore<string>('');
